import jDivisionList from '@/views/division/jDivisionList';
import jDivisionUpdate from '@/views/division/jDivisionUpdate';

import auth from '@/middleware/auth';
import log from '@/middleware/log';
import admin from '@/middleware/admin';

export default [
  {
    path: '/administrator/unit',
    name: 'jDivisionList',
    component: jDivisionList,
    meta: {
      title: 'Unit',
      middleware: [auth, admin, log],
      layout: 'jSettingWrapper',
    },
  },
  {
    path: '/administrator/unit/update/:id',
    name: 'jDivisionUpdate',
    component: jDivisionUpdate,
    meta: {
      title: 'Update Unit',
      middleware: [auth, admin, log],
      layout: 'jSettingWrapper',
    },
  },

];



// WEBPACK FOOTER //
// ./src/router/jRouterDivision.js